// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__uwNWc","insightsList":"newBusinessInsightsMenu_insightsList__3k4T_","active":"newBusinessInsightsMenu_active__1TwOg"};